import React, { Component } from 'react'
import { observer } from "mobx-react";
import 'Styles/commonComponents/FiltersPanel/FilterBlockListItems.scss';
import FilterBlock from "Components/Common/filterBlock";
import FilterListLine from "Components/Common/FiltersPanel/FilterListLine";
import IconsContainer from "Utils/IconsContainer";

class FilterBlockListItems extends Component {
    constructor() {
        super();
    }

    getRenderStore() {
        let valDefault = {
            searchAlias: ""
        };
        let ret = this.props.getRenderStore();
        if (ret == null)
            this.props.setRenderStore(valDefault);
        return ret ?? valDefault;
    }

    searchItems(toLine, empty) {
        let found = this.props.listItems
            .filter(listItem => (this.props.useSearch == false || this.getRenderStore().searchAlias?.length > 0 != true) ? true : listItem.value.toLowerCase().includes(this.getRenderStore().searchAlias.toLowerCase()));

        if (found.length > 0)
            return found.map(listItem => toLine(listItem));
        else
            return empty();


    }

    render() {
        return (
            <FilterBlock
                className={`${this.props.className} filterblock-list-items`}
                title={this.props.title}
                selectCount={this.props.value?.length ?? 0}
                showCleanButton={this.props.value?.length > 0 == true}
                clear={_ => this.props.setValue([])}
            >
                {
                    this.props.useSearch == false ? null
                        : (
                            <div className='filter-search-line-container'>
                                {IconsContainer.Get('ci-search')}
                                <input
                                    className="filter-search-line-input"
                                    onChange={(e) => this.getRenderStore().searchAlias = e.target.value}
                                    value={this.getRenderStore().searchAlias}
                                />
                            </div>
                        )
                }
                {
                    this.props.listItems?.length > 0
                        ? (
                            <div className="filter-elements overflowing-element">
                                {this.searchItems(
                                    listItem => { return (
                                        <FilterListLine
                                            key={`user-filter-${listItem.key}`}
                                            isSelected={this.props.value.some(it => it == listItem.key)}
                                            onSelected={(checkedState) => {
                                                if (checkedState)
                                                    this.props.setValue(this.props.value.concat([listItem.key]));
                                                else
                                                    this.props.setValue(this.props.value.filter(it => it != listItem.key));
                                            }}
                                            title={listItem.value}
                                            />);
                                    },
                                    () => {
                                        return this.props.emptySearchText?.length > 0
                                            ? (<div className="empty-text">{this.props.emptySearchText}</div>)
                                            : null
                                    })
                                }
                            </div>
                        )
                        : this.props.emptyText?.length > 0
                            ? (<div className="empty-text">{this.props.emptyText}</div>)
                            : null
                }
            </FilterBlock>
        );
    }
};

export default observer(FilterBlockListItems);